<template lang="pug">
.card-item(:class="{'extend-prop-type': freeExtendPropType,'is-big': !isSmall, 'is-mall': isSmall}")
  .bussiness(:class="isSmall?'':'bussiness-big'") {{item.goodsPropDesc}}
  .price(v-if="item.propType!==26" :style="isSmall?'margin-top: 0.125rem;':''")
    .best(v-if="!isSmall && item.expansionType !== 2 && item.unit !== '次' && unOpenCouponGameAB") 最高
    .num(:style="getFontSize()") {{item.amount}}
    .yuan {{item.unit}}
  .award-block(v-else) {{item.amount}}
  .card-status(:style="getMargin()")
    div() {{item.subWord}}
  </template>
<script>
import { env } from '@hb/hbridge';

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    type: {
      type: Number,
      default: 0,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    isnew: {
      type: Boolean,
      default: false,
    },
    unOpenCouponGameAB: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      env,
      op: 'opacity: 0.7;', // 已使用3
      typeMap: {
        1: '已变更',
        2: '变更后',
        3: '已膨胀',
        4: '膨胀后',
      },
    };
  },
  computed: {
    freeExtendPropType() {
      if (this.item.afterVipExtendProperty
      && this.item.afterVipExtendProperty.length > 0) {
        return this.item.afterVipExtendProperty[0].expansionType === 2;
      }
      return false;
    },
  },
  methods: {
    getMargin() {
      if (this.isSmall) {
        return 'margin-top: 0.16rem;font-size:0.15rem';
      }
      return '';
    },
    getFontSize() {
      if (this.isSmall) {
        return 'font-size: 0.36rem';
      }
      return '';
    },
    firstStatus(val, type) {
      if (!type) {
        this.$emit('click-btn', val);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.card-item {
  width: 0.77rem;
  height: 0.92rem;
  background-image: url(https://m.hellobike.com/resource/gallery/59/3ShCQVh2_Group%201707483362.png);
  background-size: 100% 100%;

  &.extend-prop-type.is-big {
    .num {
      color: #fa4614;
    }
  }

  &.extend-prop-type.is-mall {
    .num {
      color: #242729;
    }

    .yuan {
      color: #a54d08;
    }
  }

  &.extend-prop-type.is-big {
    .price {
      .num {
        font-size: 0.24rem;
      }
    }
  }

  .bussiness {
    padding-top: 0.04rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.16rem;
    font-weight: 600;
    line-height: 0.186rem;
    text-align: center;
    color: #242729;
  }

  .bussiness-big {
    font-weight: 600;
    font-size: 0.186rem;
    padding-top: 0.06rem;
  }

  .price {
    margin-top: 0.147rem;
    display: flex;
    justify-content: center;

    .best {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 400;
      font-size: 0.16rem;
      text-align: center;
      color: #a54d08;
      margin-top: 0.16rem;
      margin-right: 0.01rem;
    }

    .num {
      font-family: "DIN Alternate", sans-serif;
      font-size: 0.4184rem;
      font-weight: 700;
      line-height: 0.44rem;
      color: #242729;
    }

    .yuan {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.1744rem;
      line-height: 0.1729rem;
      font-weight: 500;
      margin-top: 0.18rem;
      text-align: center;
      color: #a54d08;
      margin-left: 0.015rem;
    }
  }

  .award-block {
    margin: 0.09rem auto 0 auto;
    width: 0.49rem;
    height: 0.49rem;
    background: url('https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png');
    background-size: 100% 100%;
    color: #7d3b2a;
    line-height: 0.49rem;
    text-align: center;
    font-weight: 700;
    font-family: "DIN Alternate", sans-serif;
  }

  .card-status {
    margin: 0 auto;
    margin-top: 0.279rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.1744rem;
    line-height: 0.2441rem;
    font-weight: 400;
    text-align: center;
    color: #7d3b2a;
  }
}
</style>
